import { render, staticRenderFns } from "./ui_spinner.vue?vue&type=template&id=cedf3b54&"
import script from "./ui_spinner.vue?vue&type=script&lang=js&"
export * from "./ui_spinner.vue?vue&type=script&lang=js&"
import style0 from "./ui_spinner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports